// extracted by mini-css-extract-plugin
var _1 = "AIButtonIconGradientDef-moduleembedded__pVFMf";
var _2 = "AIButtonIconGradientDef-moduleoffscreen__EXnDe";
export { _1 as "embedded", _2 as "offscreen" }
